import React, { useState } from 'react';
import { FormControl, Grid, InputLabel, MenuItem, Select } from '@mui/material'
import { useSelector } from 'react-redux';
import { FormControlLabel, Checkbox } from '@mui/material';

import './filterList.css'
// import { TextField } from '@mui/material';
// import { AutocompleteCustomers } from '../../../pptos_gastos/form_/AutocompleteCustomers';

export const FilterList = ({ filters, setFilters }) => {

    const { executiveList, unitList } = useSelector(state => state.general)

    // const [anchorEl, setAnchorEl] = useState(null)
    const initialFilters = filters
    // const [initialFilters, setInitialFilters] = useState(filters)
    const [form, setForm] = useState(filters)

    // const handleClose = () => {
    //     setAnchorEl(null);
    // };

    const handleChangeChecked = ({ target }) => {
        setForm({
            ...form,
            [target.name]: target.checked
        })
    }

    const handleChange = ({ target }) => {
        setForm({
            ...form,
            [target.name]: target.value
        })
    }

    const handleClean = () => {
        setFilters(initialFilters)
        setForm(initialFilters)
    }

    const handleSubmit = (e) => {
        e.preventDefault()
        setFilters({
            ...form,
            buscar: true
        })
    }

    return (
        <div>
            <form onSubmit={handleSubmit} className="row g-2 formFilterList">
                <div className="col-12">
                    <Grid container>
                        <Grid item xs={12}>
                            <Grid container spacing='20' columnSpacing='16' alignItems='center' direction='row'>
                                <Grid item xs={12}>
                                    <FormControl fullWidth size="small">
                                        <InputLabel id="demo-simple-select-label">Ejecutivos</InputLabel>
                                        <Select
                                            label="Ejecutivo"
                                            id="id_ejecutivo"
                                            name="id_ejecutivo"
                                            value={form?.id_ejecutivo || ''}
                                            onChange={handleChange}
                                            className='p-list-capitalize'
                                        >
                                            <MenuItem value='' key=''>Ninguno</MenuItem>
                                            {executiveList.map(item => (
                                                <MenuItem value={item.id} key={item.id} className='p-list-capitalize'>
                                                    {item.nombre}{' '}{item.apellidos}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>

                                </Grid>
                                <Grid item xs={12}>
                                    <FormControl fullWidth size="small">
                                        <InputLabel id="demo-simple-select-label">Unidad de negocio</InputLabel>
                                        <Select
                                            label="Unidad de negocio"
                                            id="id_unit"
                                            name="id_unit"
                                            onChange={handleChange}
                                            value={form?.id_unit || ''}
                                            className='p-list-capitalize'
                                        >
                                            <MenuItem value='' key=''>Ninguno</MenuItem>
                                            {unitList.map(item => (
                                                <MenuItem value={item.id} key={item.id} className='p-list-capitalize'>{item.nombre}</MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </div>

                <div className="col-4 selectSpan">
                    <FormControlLabel
                        className='formControFilterList'
                        control={
                            <Checkbox
                                checked={form?.check_proceso}
                                onChange={handleChangeChecked}
                                name="check_proceso"
                                color='secondary'
                            />
                        }
                        label="En proceso"
                    />
                </div>

                <div className="col-4 selectSpan">
                    <FormControlLabel
                        className='formControFilterList'
                        control={
                            <Checkbox
                                checked={form?.check_standby}
                                onChange={handleChangeChecked}
                                name="check_standby"
                                color="secondary"
                            />
                        }
                        label="Stand-by"
                    />
                </div>

                <div className="col-4 selectSpan">
                    <FormControlLabel
                        className='formControFilterList'
                        control={
                            <Checkbox
                                checked={form?.check_cerrada}
                                onChange={handleChangeChecked}
                                name="check_cerrada"
                                color="secondary"
                            />
                        }
                        label="Cerradas"
                    />
                </div>

                <div className="col-6 selectSpan">
                    <FormControlLabel
                        className='formControFilterList'
                        control={
                            <Checkbox
                                checked={form?.facturado}
                                onChange={handleChangeChecked}
                                name="facturado"
                                color='secondary'
                            />
                        }
                        label="Facturado"
                    />
                </div>
                <div className="col-6 selectSpan">
                    <FormControlLabel
                        className='formControFilterList'
                        control={
                            <Checkbox
                                checked={form?.por_facturar}
                                onChange={handleChangeChecked}
                                name="por_facturar"
                                color="secondary"
                            />
                        }
                        label="Por facturar"
                    />
                </div>

                <div className="col-12 formFilterListButtons">
                    <button
                        type="button" className="btn btn-light buttonLimpiarFiltro"
                        onClick={handleClean}
                    >
                        Limpiar filtros
                    </button>
                    <button
                        type="button" className="btn btn-primary buttonBuscar"
                        onClick={handleSubmit}>
                        Buscar
                    </button>
                </div>
            </form>
        </div>
    )
}
